import * as React from "react";
import {
    Theme,
    makeStyles,
    Container,
    Typography,
    Link
} from "@material-ui/core";
import CopyrightIcon from "@material-ui/icons/Copyright";

import TraceroNoTagLogo from "../../../assets/logos/logo_no_tagline.svg";

function Copyright() {
    return (
        <Link href="https://www.tracerco.com">
            <CopyrightIcon
                className="material-icons"
                style={{ fontSize: "12px" }}
            ></CopyrightIcon>
            {new Date().getFullYear()} Tracerco. All rights reserved.
        </Link>
    );
}

const useStyles = makeStyles((theme: Theme) => ({
    contactDetails: {
        color: theme.palette.primary.main,
        padding: theme.spacing(22, 6)
    },
    contactLogo: {
        marginBottom: theme.spacing(4)
    },
    contactJMLogo: {
        marginTop: theme.spacing(4),
        width: "193px"
    },
    footer: {
        padding: theme.spacing(7.5),
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.primary.main
    }
}));

const FooterArea: React.FC = () => {
    const classes = useStyles();

    return (
        <>
            <Container
                component="section"
                maxWidth="lg"
                className={classes.contactDetails}
            >
                <Typography component="div" variant="body1">
                    <img
                        src={TraceroNoTagLogo}
                        alt="Tracerco"
                        className={classes.contactLogo}
                    />
                    <Typography component="address">
                        Tracerco is a trade name of Tracerco Limited<br />
                        Measurement Technology Centre<br />
                        The Moat, Belasis Hall Technology Park<br />
                        Billingham TS23 4ED<br />
                        Company No. 4496566<br />
                    </Typography>
                </Typography>
            </Container>
            <footer className={classes.footer}>
                <Typography variant="subtitle2" align="left" component="div">
                    <Copyright />
                    &nbsp;
                    <Link
                        underline="always"
                        href="https://www.tracerco.com/privacy-notice"
                    >
                        Privacy notice.
                    </Link>
                    &nbsp;
                    <Link
                        underline="always"
                        href="https://www.tracerco.com/cookies-notice"
                    >
                        Cookies notice.
                    </Link>
                    &nbsp;
                    <Link
                        underline="always"
                        href="https://www.tracerco.com/terms-of-use/"
                    >
                        Terms of use.
                    </Link>
                    &nbsp;
                </Typography>
            </footer>
        </>
    );
};

export default FooterArea;
